module.exports = __webpack_public_path__ + "assets/chevron-down-4252c6.svg";